document.addEventListener('DOMContentLoaded', () => {

    const recipes = [
        {
            id: 'hafragrautur-sukkuladi',
            title: 'Súkkulaði Prótein hafragrautur',
            categories: ['morgunmatur'],
            imageUrl: 'https://cdn.shopify.com/s/files/1/0763/1306/7771/files/Chocolate-Protein-Oatmeal-New-Chapter-11.19-image-8.jpg?v=1751715722',
            baseIngredients: ['40g hafrar', '1 skeið súkkulaði prótein', '1 tsk cocoa powder', 'Salt eftir smekk'],
            variations: [
                { name: 'Toppur 1', ingredients: ['25g hvítt súkkulaði frá GoodGood', '10g karamellu kókosflögur'], macros: { kcal: 451, p: 29.6, k: 44.6, f: 18.4 }},
                { name: 'Toppur 2', ingredients: ['100g banani', '25g hvítt súkkulaði'], macros: { kcal: 476, p: 30.3, k: 64, f: 13.7 }},
                { name: 'Toppur 3', ingredients: ['20g prótein súkkulaði granóla', '100g banani'], macros: { kcal: 443, p: 33.2, k: 60, f: 8.5 }},
                { name: 'Toppur 4', ingredients: ['20g prótein súkkulaði granóla', '25g hvítt GoodGood súkkulaði'], macros: { kcal: 475, p: 32.7, k: 38.4, f: 17.2 }}
            ]
        },
        {
            id: 'chiagrautur-sukkuladi',
            title: 'Súkkulaði Prótein chiagrautur (overnight)',
            categories: ['morgunmatur', 'millimal'],
            imageUrl: 'https://cdn.shopify.com/s/files/1/0763/1306/7771/files/20190911EFK-1240-scaled.jpg?v=1751718238',
            baseIngredients: ['15g chia fræ', '1dl kókosmjólk', '1 skeið súkkulaði prótein frá ON', '1 tsk cocoa powder', '40g vanilluskyr'],
            variations: [
                { name: 'Toppur 1', ingredients: ['20g hvítt súkkulaði frá GoodGood', '20g prótein súkkulaði granóla'], macros: { kcal: 466, p: 34.9, k: 36.3, f: 18.4 }},
                { name: 'Toppur 2', ingredients: ['100g banani', '20g hvítt súkkulaði'], macros: { kcal: 468, p: 32.5, k: 49.1, f: 14.9 }},
                { name: 'Toppur 3', ingredients: ['20g prótein súkkulaði granóla', '100g banani'], macros: { kcal: 459, p: 35.6, k: 58.3, f: 11.5 }}
            ]
        },
        {
            id: 'breakfast-tortilla',
            title: 'Breakfast tortilla',
            categories: ['morgunmatur'],
            imageUrl: 'https://cdn.shopify.com/s/files/1/0763/1306/7771/files/Breakfast-Tortillas-Edited-15-e1589438293860.jpg?v=1751718245',
            baseIngredients: ['Heilhveiti tortilla', '2 egg', '1 sneið af osti', 'Hálft avocado', '20g rjómaostur'],
            variations: [],
            macros: { kcal: 461, p: 21.2, k: 22, f: 30.5 }
        },
        {
            id: 'hafragrautur-vanillu',
            title: 'Overnight protein hafragrautur',
            categories: ['morgunmatur'],
            imageUrl: 'https://cdn.shopify.com/s/files/1/0763/1306/7771/files/proteinovernightoats-2.jpg?v=1751718266',
            baseIngredients: ['40g hafrar', '10g chia fræ', '1 skeið vanillu prótein', '150 ml möndlumjólk án sykurs', '50g frosin bláber', '½ tsk kanill eða eftir smekk'],
            variations: [
                { name: 'Toppur 1', ingredients: ['50g epli', '15g prótein súkkulaði granóla'], macros: { kcal: 445, p: 34.5, k: 53.4, f: 11.8 }},
                { name: 'Toppur 2', ingredients: ['50g banani', 'Súkkulaði prótein granóla'], macros: { kcal: 464, p: 34.9, k: 57.3, f: 11.8 }}
            ]
        },
        {
            id: 'hakkskal-1',
            title: 'Hakkskál 1',
            categories: ['hadegismatur', 'kvoldmatur'],
            imageUrl: 'https://cdn.shopify.com/s/files/1/0763/1306/7771/files/img_5e55c458d25ff.webp?v=1751718254',
            baseIngredients: ['150g ungnautahakk', '70g gúrka', '20g fetaostur', '20g tómatsósa (sykurlaus frá felix)', '100g mangó'],
            variations: [],
            macros: { kcal: 348, p: 27.6, k: 16.9, f: 18.8 }
        }
    ];

    const grid = document.getElementById('recipe-grid-container');
    const searchInput = document.getElementById('recipe-search-input');
    const filterButtons = document.querySelectorAll('.tab-button');
    const modalOverlay = document.getElementById('recipe-modal-overlay');

    if (!grid || !modalOverlay) { return; }

    const modal = {
        image: document.getElementById('modal-image'),
        title: document.getElementById('modal-title'),
        body: document.getElementById('modal-body'),
        closeButton: modalOverlay.querySelector('.modal-close-button'),
    };
    
    AOS.init({ duration: 800, once: true });

    const categoryNames = {
        'morgunmatur': 'Morgunmatur',
        'hadegismatur': 'Hádegismatur',
        'kvoldmatur': 'Kvöldmatur',
        'millimal': 'Millimál'
    };

    function displayRecipes(recipeList) {
        grid.innerHTML = '';
        recipeList.forEach(recipe => {
            const card = document.createElement('div');
            card.className = 'recipe-card';
            card.dataset.id = recipe.id;
            
            const categoryName = categoryNames[recipe.categories[0]] || 'Almennt';
            const macros = recipe.macros || (recipe.variations[0] && recipe.variations[0].macros);
            
            card.innerHTML = `
                <img src="${recipe.imageUrl}" alt="${recipe.title}">
                <div class="recipe-card-content">
                    <span class="recipe-category-tag">${categoryName}</span>
                    <h3>${recipe.title}</h3>
                    <p>Smelltu til að sjá innihald og næringargildi.</p>
                    <div class="recipe-meta">
                        <span><i class="fas fa-utensils"></i> ${recipe.variations.length > 0 ? recipe.variations.length + ' útgáfur' : '1 útgáfa'}</span>
                        ${macros ? `<span><i class="fas fa-fire-alt"></i> ~${macros.kcal} kkal</span>` : ''}
                    </div>
                    <button class="btn-go recipe-open-button" data-id="${recipe.id}">Skoða uppskrift</button>
                </div>
            `;
            grid.appendChild(card);
        });
        AOS.refresh();
    }

    function openModal(recipeId) {
        const recipe = recipes.find(r => r.id === recipeId);
        if (!recipe) return;
        modal.image.src = recipe.imageUrl;
        modal.title.textContent = recipe.title;
        let bodyHtml = `<h4>Grunnuppskrift:</h4><ul>${recipe.baseIngredients.map(i => `<li>${i}</li>`).join('')}</ul>`;

        if (recipe.variations.length > 0) {
            recipe.variations.forEach(v => {
                bodyHtml += `<div class="variation-card"><h5>${v.name} - Innihald:</h5><ul>${v.ingredients.map(i => `<li>${i}</li>`).join('')}</ul><div class="macros"><div><span class="macro-label">Hitaeiningar</span><span class="macro-value">${v.macros.kcal}</span></div><div><span class="macro-label">Prótein</span><span class="macro-value">${v.macros.p}g</span></div><div><span class="macro-label">Kolvetni</span><span class="macro-value">${v.macros.k}g</span></div><div><span class="macro-label">Fita</span><span class="macro-value">${v.macros.f}g</span></div></div></div>`;
            });
        } else {
            bodyHtml += `<div class="variation-card"><h5>Næringargildi:</h5><div class="macros"><div><span class="macro-label">Hitaeiningar</span><span class="macro-value">${recipe.macros.kcal}</span></div><div><span class="macro-label">Prótein</span><span class="macro-value">${recipe.macros.p}g</span></div><div><span class="macro-label">Kolvetni</span><span class="macro-value">${recipe.macros.k}g</span></div><div><span class="macro-label">Fita</span><span class="macro-value">${recipe.macros.f}g</span></div></div></div>`;
        }
        
        modal.body.innerHTML = bodyHtml;
        modalOverlay.style.display = 'flex';
        document.body.style.overflow = 'hidden';
    }

    function closeModal() {
        modalOverlay.style.display = 'none';
        document.body.style.overflow = 'auto';
    }

    function filterAndSearch() {
        const filterValue = document.querySelector('.tab-button.active').dataset.filter;
        const searchValue = searchInput.value.toLowerCase();
        const filteredRecipes = recipes.filter(recipe => {
            const matchesFilter = filterValue === 'all' || recipe.categories.includes(filterValue);
            const matchesSearch = recipe.title.toLowerCase().includes(searchValue);
            return matchesFilter && matchesSearch;
        });
        displayRecipes(filteredRecipes);
    }

    filterButtons.forEach(button => {
        button.addEventListener('click', () => {
            filterButtons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');
            filterAndSearch();
        });
    });

    if(searchInput) searchInput.addEventListener('input', filterAndSearch);

    grid.addEventListener('click', (e) => {
        const openButton = e.target.closest('.recipe-open-button');
        if (openButton) {
            openModal(openButton.dataset.id);
        }
    });

    modal.closeButton.addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', (e) => { if (e.target === modalOverlay) closeModal(); });
    
    displayRecipes(recipes);
});